import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=264ab8ff&scoped=true"
import script from "./SupportTicket.vue?vue&type=script&lang=js"
export * from "./SupportTicket.vue?vue&type=script&lang=js"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&id=264ab8ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ab8ff",
  null
  
)

export default component.exports